export default __webpack_public_path__ + "static/media/Holiday-Big.e1a2bdb8.png";